import React, { useContext, useEffect, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import 'materialize-css'
import { Container, Card, Row, Col, Button, TextInput, Select } from 'react-materialize'
import { HeaderCittadino } from '../components/HeaderCittadino'
import { PageFooter } from "../components/PageFooter"
import { LoadingFull } from "../components/loadingFull"
import { GlobalContext } from '../context/GlobalState'
import { useTokenCittadino } from "../components/hooks/useTokenCittadino"
import { useGeneraIdCarrello } from '../components/hooks/useGeneraIdCarrello';


export const CarrelloPage = () => {
    const debug = process.env.REACT_APP_DEBUG === "true"
    const history = useHistory()
    const location = useLocation()
    const queryString = require('query-string')
    const parsed = queryString.parse(location.search)
    const { idCarrello } = parsed
    const datiRichiesta = JSON.parse(localStorage.getItem(idCarrello));
    const [ identificativoVersante, setIdentificativoVersante ] = useState("")
    const [ mailVersante, setMailVersante ] = useState("")
    const [ anagraficaVersante, setAnagraficaVersante ] = useState("")
    const [ tipoVersante, setTipoVersante ] = useState("F")
    const [ invioPagamento, setInvioPagamento ] = useState(false)
    const { token } = useTokenCittadino()
    const generaIdCarrello = useGeneraIdCarrello()
    if (debug) console.log('LOCATION', location)

    const { 
        carrello, 
        removePendenzaCarrello, 
        svuotaCarrello,
        setCarrello,
        provincia,
        ente,
        servizio,
        strutturaSelettori,
        saveContext,
        cittadino 
    } = useContext(GlobalContext);

    useEffect(
        () => {
            if (!carrello.length) {
                if (datiRichiesta && datiRichiesta.carrello) {
                    setCarrello(datiRichiesta.carrello)
                }
            }
        }, 
        [datiRichiesta, carrello]
    )

    saveContext()

    if (debug) console.log({carrello, strutturaSelettori})

    const getNomeEnte = (idDominio) => {
        let nomeEnte = ""
        
        let province = Object.keys(strutturaSelettori)

        province.forEach(
            (provincia) => {
                let enti = strutturaSelettori[provincia].enti
                enti.forEach(
                    (ente) => {
                        if (ente.idDominio === idDominio) {
                            nomeEnte = ente.ragioneSociale
                        }
                    }
                )
            }
        )

        return nomeEnte
    }

    const pulisciCarrello = () => {
        svuotaCarrello()
        saveContext()
    }

    const aggiungiPagamento = () => {
        history.push('/pagamento')
    }

    const modificaPendenza = (index) => {
        if (debug) console.log('MODIFICA: '+index)
        if (debug) console.log("P: "+provincia, "E: "+ente, "S: "+servizio)
        if (debug) console.log('/pagamento?modifica='+index)
        localStorage.removeItem(idCarrello)
        history.push('/pagamento?modifica='+index)
    }

    const eliminaPendenza = (index) => {
        if (debug) console.log('RIMUOVI: '+index)
        localStorage.removeItem(idCarrello)
        document.location.href = '/carrello'
        removePendenzaCarrello(index)
        saveContext()
    }

    // const eseguiPagamento = () => {
    //     let soggettoVersante = {
    //         tipo: "",
    //         identificativo: "",
    //         anagrafica: ""
    //     }

    //     if (token) {
    //         soggettoVersante.identificativo = cittadino.cf
    //         soggettoVersante.anagrafica = (cittadino.nome + " " + cittadino.cognome).trim()
    //         soggettoVersante.tipo = "F"
    //     } else {
    //         soggettoVersante.identificativo = identificativoVersante
    //         soggettoVersante.anagrafica = anagraficaVersante
    //         soggettoVersante.tipo = tipoVersante
    //     }

    //     let pagamenti = {
    //         urlRitorno: window.location.origin + "/esito_pagamento",
    //         pendenze: carrello.map((item) => {
    //             if(item.datiPendenza) {
    //                 return item.datiPendenza
    //             } else {
    //                 return item
    //             }
    //         }),
    //         soggettoVersante
    //     }

    //     pulisciCarrello()
    //     if (debug) console.log(carrello, pagamenti)

    //     fetch(process.env.REACT_APP_SERVER_URL + 'richiedi_pagamento?richiedente=' + soggettoVersante.identificativo, {
    //         method: 'POST',
    //         body: JSON.stringify(pagamenti)
    //     })
    //         .then(response => response.json())
    //         .then(data => {                
    //             if (debug) console.log(data)
    //             if (data.redirect) {                    
    //                 localStorage.setItem("richiestaPagamento", JSON.stringify(data))
    //                 window.open(data.redirect, '_self')
    //             } else {
    //                 localStorage.setItem("error", JSON.stringify(data))
    //                 history.push('/error')
    //             }
    //         });
    // }


    const elaboraCarrello = () => {
        console.log({cittadino})
        const richiedente = token ? cittadino.cf : identificativoVersante
        
        fetch(process.env.REACT_APP_SERVER_URL + 'cittadino/elabora_carrello?richiedente=' + richiedente, {
            method: 'POST',
            body: JSON.stringify({ token, carrello, richiedente })
        })
            .then(response => response.json())
            .then(iuvList => {                
                if (debug) console.log({iuvList})
                checkout(iuvList)
                // if (data.redirect) {                    
                //     localStorage.setItem("richiestaPagamento", JSON.stringify(data))
                //     window.open(data.redirect, '_self')
                // } else {
                //     localStorage.setItem("error", JSON.stringify(data))
                //     history.push('/error')
                // }
            });
    }


    const checkout = (iuvList) => {
        const idCart = idCarrello ?? generaIdCarrello()
        const emailNotice = token ? cittadino.email : mailVersante
        const paymentNotices = []

        for (let item of carrello) {
            if (item.numeroAvviso) {
                paymentNotices.push({
                    noticeNumber: iuvList[item.idPendenza],
                    fiscalCode: item.dominio.idDominio,
                    amount: item.importo * 100,
                    companyName: item.dominio.ragioneSociale,
                    description: item.causale
                })
            } else {
                paymentNotices.push({
                    noticeNumber: iuvList[item.datiPendenza.idPendenza],
                    fiscalCode: item.datiPendenza.idDominio,
                    amount: item.datiPendenza.importo * 100,
                    companyName: getNomeEnte(item.datiPendenza.idDominio),
                    description: item.datiPendenza.causale
                })
            }
        }

        const returnOkUrl = `${window.location.origin}/esito_pagamento?idCarrello=${idCart}&esito=OK`
        const returnCancelUrl = `${window.location.origin}/esito_pagamento?idCarrello=${idCart}&esito=CANCEL`
        const returnErrorUrl = `${window.location.origin}/esito_pagamento?idCarrello=${idCart}&esito=ERROR`

        const checkoutData = {
            emailNotice,
            paymentNotices,
            returnUrls: {
                returnOkUrl,
                returnCancelUrl,
                returnErrorUrl
            },
            idCart,
            allCCP: false
        }

        console.log({checkoutData})

        localStorage.setItem(idCart, JSON.stringify({carrello, iuvList, checkoutData}))

        setInvioPagamento(true)

        fetch(process.env.REACT_APP_CHECKOUT_URL, {
            method: 'POST',
            headers: { 
                'Content-Type': 'application/json; charset=UTF-8'
            },
            body: JSON.stringify(checkoutData)
        }).then(
            (response) => {
                const { status, url } = response
                console.log({status, url})
                setInvioPagamento(false)
                if (status === 200 && url) {
                    window.open(url, '_self')
                } else {
                    history.push(`/esito_pagamento?idCarrello=${idCart}&esito=ERROR`)
                }
            }
        )
    }


    const handleChange = (e) => {
        let id = e.target.id
        let value = e.target.value
        
        if (id === "identificativoVersante") setIdentificativoVersante(value)
        if (id === "mailVersante") setMailVersante(value)
        if (id === "anagraficaVersante") setAnagraficaVersante(value)
        if (id === "tipoVersante") setTipoVersante(value)
    }


    const checkVersante = () => {
        if (token && cittadino) return false

        if (anagraficaVersante.length > 0 && /\S+@\S+\.\S+/.test(mailVersante)) {
            if (tipoVersante === "F" && identificativoVersante.length === 16) return false             
            if (tipoVersante === "G" && identificativoVersante.length === 11) return false
        }
        
        return true
    }


    return (
        <>
            <Container>
                <HeaderCittadino history={history} />
                { invioPagamento ? <LoadingFull /> : <></> }
                <Row>
                    <Col s={12}>
                    {
                        carrello.length ?
                        carrello.map(
                            (item, index) => (<Card key={index}>
                                {
                                    item.numeroAvviso ?
                                    <>
                                        <Row>
                                            <Col s={12}>
                                                <b>Numero avviso:</b> {item.numeroAvviso}<br />
                                                <b>Causale:</b> {item.causale}<br />
                                                <b>Ente creditore:</b> {item.dominio.ragioneSociale}<br />
                                                <b>Dominio:</b> {item.dominio.idDominio}<br />
                                                <b>Anagrafica debitore:</b> {item.soggettoPagatore.anagrafica}<br />
                                                <b>Codice fiscale:</b> {item.soggettoPagatore.identificativo}<br />
                                                <b>Importo:</b> € {item.importo}<br />
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col>
                                                <Button onClick={() => eliminaPendenza(index)}>ELIMINA</Button>
                                            </Col>
                                        </Row>
                                    </> :
                                    <>
                                        <Row style={{marginBottom: 0}}>
                                            <Col s={12}>
                                                <b>Soggetto Debitore:</b> {item.datiPendenza.soggettoPagatore.anagrafica}
                                            </Col>
                                        </Row>
                                        <Row style={{marginBottom: 0}}>
                                            <Col s={12}>
                                                <b>Ente Creditore:</b> {getNomeEnte(item?.datiPendenza?.idDominio)}
                                            </Col>
                                        </Row>
                                        <Row style={{marginBottom: 0}}>
                                            <Col s={12}>
                                                <b>Servizio:</b> {item.datiPendenza.voci[0].descrizione}
                                            </Col>
                                        </Row>
                                        <Row style={{marginBottom: 0}}>
                                            <Col s={12}>
                                                <b>Causale:</b> {item.datiPendenza.causale}
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col s={12}>
                                                <b>Importo:</b> € {item.datiPendenza.importo}
                                            </Col>
                                        </Row>
                                        <Row style={{marginBottom: 0}}>
                                            <Col>
                                                <Button onClick={() => modificaPendenza(index)}>MODIFICA</Button> <Button onClick={() => eliminaPendenza(index)}>ELIMINA</Button>
                                            </Col>
                                        </Row>
                                    </>
                                }
                            </Card>)
                        ) :
                        <Card>
                            <Row>
                                <Col>
                                    <p>NON CI SONO ELEMENTI NEL CARRELLO</p>
                                </Col>
                            </Row>
                        </Card>
                    }
                    </Col>
                </Row>
                <Row>
                    <Col s={12}>
                        <Card title="Dati del Soggetto Versante">
                            {
                                token && cittadino ?
                                <Row>
                                    <Col s={12}><b>ANAGRAFICA:</b> {(cittadino.nome + " " + cittadino.cognome).trim()}</Col>
                                    <Col s={12}><b>C.F. / P.IVA:</b> {cittadino.cf}</Col>
                                    <Col s={12}><b>Mail:</b> {cittadino.email}</Col>
                                </Row> :
                                <Row>
                                    <Col m={12} l={6}>
                                        <Select s={12} id="tipoVersante" onChange={handleChange} value={tipoVersante} >
                                            <option value="F">PERSONA FISICA</option>
                                            <option value="G">PERSONA GIURIDICA</option>
                                        </Select>
                                    </Col>
                                    <Col m={12} l={6}>
                                        <TextInput s={12} label="Codice Fiscale / P.IVA (*)" id="identificativoVersante" onChange={handleChange} value={identificativoVersante} minLength={tipoVersante === "G" ? 11 : 16} maxLength={tipoVersante === "G" ? 11 : 16} validate required  />
                                    </Col>
                                    <Col m={12} l={6}>
                                        <TextInput s={12} label="Nome e Cognome / Rag. Sociale (*)" id="anagraficaVersante" onChange={handleChange} value={anagraficaVersante} validate required  />
                                    </Col>
                                    <Col m={12} l={6}>
                                        <TextInput s={12} label="E-Mail per ricevuta (*)" id="mailVersante" onChange={handleChange} value={mailVersante} validate required  />
                                    </Col>
                                </Row>
                            }
                        </Card>
                    </Col>
                </Row>
                {
                    carrello.length ?
                    <>
                        <Row>
                            <Col s={12}>
                                <p>Puoi aggiungere altri pagamenti al carrello oppure procedere con l'esecuzione del pagamento per le pendenze presenti nel carrello.</p>
                                <p><b>NB:</b> Al momento ci risultano errori in fase di elaborazione da PagoPA per carrelli che contengono più di una pendenza, qualora dovessero verificarsi consigliamo di rimuovere le pendenze multiple e pagarle una alla volta in un secondo momento.</p>
                            </Col>
                        </Row>
                        <Row>
                            <Col s={12} m={4}>
                                <Button node="button" waves="light" style={{width:'100%'}} large onClick={pulisciCarrello}>SVUOTA CARRELLO</Button>
                            </Col>
                            <Col s={12} m={4}>
                                <Button node="button" waves="light" style={{width:'100%'}} large onClick={aggiungiPagamento} disabled={carrello.length > 0}>AGGIUNGI UN PAGAMENTO</Button>
                            </Col>
                            <Col s={12} m={4}>
                                {/* <Button node="button" waves="light" style={{width:'100%'}} large onClick={eseguiPagamento} disabled={checkVersante()}>ESEGUI PAGAMENTO</Button> */}
                                <Button node="button" waves="light" style={{width:'100%'}} large onClick={elaboraCarrello} disabled={checkVersante() || invioPagamento}>{ invioPagamento ? "ELABORAZIONE IN CORSO..." : "ESEGUI PAGAMENTO" }</Button>
                            </Col>
                        </Row>
                    </> : 
                    null
                }
                <PageFooter />
            </Container>
        </>
    );
}